import {
    RESOURCE_BUNDLE_ACTION_BEGIN,
    RESOURCE_BUNDLE_ACTION_SUCCESS,
    RESOURCE_BUNDLE_ACTION_FAIL
  } from '../middleware/types'
  
  const initialState = {
    RESOURCE_BUNDLE_LOADING: false,
    error: {},
    response:{}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case RESOURCE_BUNDLE_ACTION_BEGIN:
        return {
          ...state,
          RESOURCE_BUNDLE_LOADING: true
        }
      case RESOURCE_BUNDLE_ACTION_SUCCESS:
          return {
              ...state,
              RESOURCE_BUNDLE_LOADING: false,
              response:{
                ...action.payload
              }
            }
      case RESOURCE_BUNDLE_ACTION_FAIL:
        return {
          ...state,
          RESOURCE_BUNDLE_LOADING: false,
          error: action.payload
        }
      default:
        return state
    }
  }